import { SpotlightDocumentSchema } from "@redotech/redo-spotlight-common/spotlight-document-schema";
import { SpotlightFormSchema } from "@redotech/redo-spotlight-common/spotlight-schema";
import * as z from "zod/v4";

export const createSpotlight = {
  name: "createSpotlight" as const,
  input: z.object({ form: SpotlightFormSchema }),
  output: z.object({ spotlight: SpotlightDocumentSchema }),
};
